import { IEditVideoCategoryState } from './editVideoCategoryContext';
import { EditVideoCategoryActionTypes, TEditVideoCategoryAction } from './editVideoCategoryActions';

export const editVideoCategoryReducer = (
	state: IEditVideoCategoryState,
	action: TEditVideoCategoryAction,
): IEditVideoCategoryState => {
	switch (action.type) {
		case EditVideoCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditVideoCategoryActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditVideoCategoryActionTypes.SET_ALL_DATA:
			return {
				...state,
				categoryID: action.payload.categoryID,
				name: action.payload.name,
				IDsSelectedLanguages: action.payload.IDsSelectedLanguages,
				translations: action.payload.translations,
			};
		case EditVideoCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditVideoCategoryActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditVideoCategoryActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case EditVideoCategoryActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case EditVideoCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case EditVideoCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditVideoCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case EditVideoCategoryActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditVideoCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditVideoCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				fetchedLanguages: [],
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				translations: [],
			};
		default:
			return state;
	}
};
